import Button from "@metacrm/metacrm-material-ui/dist/Button";
import { Box } from "@mui/material";
import React from "react";
import { StyledSkeleton } from "./WidgetPreview.styles";

export default function XmtpPreview({ formData, disabled }) {
  const { title, content, image, buttonText, buttonUrl, sendTime } = formData;

  function handleUrl() {
    if (!buttonUrl) return;
    window.open(buttonUrl, "_blank", "noopener noreferrer");
  }

  return (
    <Box
      bgcolor="#EDEDED"
      p="25.5px 16px 0"
      minHeight="639px"
      sx={{ opacity: disabled ? 0.5 : 1 }}
      fontSize={14}
      color="#555"
    >
      <Box
        width="100%"
        height="100%"
        bgcolor="#FFFFFF"
        p="36px"
        minHeight="639px"
      >
        {title ? (
          <Box mb="20px">{title}</Box>
        ) : (
          <StyledSkeleton width="221px" mb="20px" />
        )}

        {image && (
          <Box
            component="img"
            mb="20px"
            width="100%"
            sx={{ objectFit: "cover" }}
            height="auto"
            src={image}
          />
        )}
        {content ? (
          <Box mb="34px" sx={{ wordBreak: "break-all" }}>
            {content}
          </Box>
        ) : (
          <Box mb="34px">
            <StyledSkeleton light mb="12px" />
            <StyledSkeleton light mb="12px" />
            <StyledSkeleton light mb="12px" />
          </Box>
        )}
        {buttonText && <Button onClick={handleUrl}>{buttonText}</Button>}
      </Box>
    </Box>
  );
}
